import * as THREE from 'three';
import { Weapon, WeaponConfig } from './Weapon';
import { Mine } from '../entities/Mine';

export class MineWeapon extends Weapon {
  constructor() {
    const config: WeaponConfig = {
      name: '地雷',
      type: 'mine',
      damage: 80,
      cooldown: 1.5,
      ammo: 5,
      maxAmmo: 5,
      areaOfEffect: 6 // 6 unit radius
    };
    super(config);
  }

  createProjectile(
    position: THREE.Vector3,
    direction: THREE.Vector3,
    owner: 'player' | 'enemy'
  ): Mine {
    // Mines are placed slightly behind the tank
    const minePosition = position.clone().add(direction.clone().multiplyScalar(-2));
    minePosition.y = 0.2; // Slightly above ground
    return new Mine(minePosition, owner, this.config.damage, this.config.areaOfEffect!);
  }
}
